import snakeize from 'snakeize';

import LocalForage from 'app/utils/localForage';

import { PLATFORMS } from 'app/utils/constants';

const { APP_ENV } = process.env;
const __PROD__ = APP_ENV === 'production';

const BRAZE_TYPES = {
  bool: 'Boolean',
  string: 'String',
  array: 'Array',
  int: 'Integers',
  date: 'Date',
};

const brazeLogCustomEvent = (name, params = {}, platform, version, source) => {
  const newParams = {
    source,
    ...params,
  };

  if (!__PROD__) {
    console.log('%cbraze', 'color: #20a2ae;', name, newParams);
  }

  if (!name || !platform || !version) {
    return;
  }

  if (window.BrazeWebInterface) {
    // Call Android interface
    window.BrazeWebInterface.logCustomEvent(
      name,
      JSON.stringify(snakeize(newParams))
    );
  } else if (
    window.webkit &&
    window.webkit.messageHandlers &&
    window.webkit.messageHandlers.chatie
  ) {
    // Call iOS interface
    const message = {
      command: 'braze:logCustomEvent',
      name,
      parameters: snakeize(newParams),
    };
    window.webkit.messageHandlers.chatie.postMessage(message);
  }
};

const setBrazeCustomUserAttribute = (
  key,
  valueToParse,
  type,
  platform,
  version
) => {
  let value = valueToParse;
  switch (type) {
    case BRAZE_TYPES.date:
      value = valueToParse.toISOString();
      break;
    default:
      value = valueToParse;
  }

  if (!__PROD__) {
    console.log('%cbraze', 'color: #20a2ae;', key, value, type);
  }

  if (!key || !platform || !version) {
    return;
  }

  if (window.BrazeWebInterface) {
    // Call Android interface
    window.BrazeWebInterface.setCustomUserAttribute(key, value, type);
  } else if (
    window.webkit &&
    window.webkit.messageHandlers &&
    window.webkit.messageHandlers.chatie
  ) {
    // Call iOS interface
    const message = {
      command: 'braze:setCustomUserAttribute',
      key,
      value,
      type,
    };
    window.webkit.messageHandlers.chatie.postMessage(message);
  }
};

class BrazeDispatcher {
  constructor(store, interface_) {
    this.store = store;
    this.interface = interface_;

    const { platform, version } = this.store.getState().common;

    this.platform = platform;
    this.version = version;
  }

  logCustomEvent = (name, params = {}) => {
    const { source } = this.store.getState().common;

    brazeLogCustomEvent(name, params, this.platform, this.version, source);
  };

  setCustomAttribute = (key, value, type) => {
    setBrazeCustomUserAttribute(key, value, type, this.platform, this.version);
  };

  setLastReadStoryId = (value) => {
    const key = 'last_read_story_id';
    const localKey = 'lastReadStoryId';

    LocalForage.getItem(localKey)
      .then((lastReadStoryId) => {
        if (lastReadStoryId === value) {
          return Promise.resolve(null);
        }

        return LocalForage.setItem(localKey, value);
      })
      .then((value_) => {
        if (value_ === null) {
          return;
        }

        setBrazeCustomUserAttribute(key, value, BRAZE_TYPES.int);
      })
      .catch(() => {
        setBrazeCustomUserAttribute(key, value, BRAZE_TYPES.int);
      });
  };
}

export default {
  BRAZE_TYPES,
  brazeLogCustomEvent,
  setBrazeCustomUserAttribute,
  BrazeDispatcher,
};



// WEBPACK FOOTER //
// ./src/app/utils/braze.js